import type {
    CreateSignOffTemplateRequest,
    ISignOffTemplate,
    ISignOffTemplateFilter,
    SignOffTemplateExpandOpts,
    UpdateSignOffTemplateParams,
} from '@condo/domain';
import { getClient } from './api-client';

export const getSignOffTemplates = async (
    params?: ISignOffTemplateFilter,
    expand?: SignOffTemplateExpandOpts,
): Promise<{ signOffTemplates: ISignOffTemplate[]; total: number }> =>
    getClient('basecamp')
        .get('/sign-off-templates', { params: { ...params, expand } })
        .then(response => response.data);

export const getSignOffTemplate = async (signOffTemplateId: number, expand?: SignOffTemplateExpandOpts): Promise<{ template: Partial<ISignOffTemplate> }> =>
    getClient('basecamp')
        .get(`/sign-off-templates/${signOffTemplateId}`, { params: { expand } })
        .then(response => response.data);

export const createSignOffTemplate = async (signOffTemplate: CreateSignOffTemplateRequest): Promise<{ template: ISignOffTemplate }> =>
    getClient('basecamp')
        .post('/sign-off-templates', signOffTemplate)
        .then(response => response.data);

export const updateSignOffTemplate = async (
    signOffTemplateId: number,
    signOffTemplate: UpdateSignOffTemplateParams['signOffTemplate'],
): Promise<{ template: ISignOffTemplate }> =>
    getClient('basecamp')
        .patch(`/sign-off-templates/${signOffTemplateId}`, { signOffTemplate })
        .then(response => response.data);
